// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 76px;
  background: var(--ui-surface);
  padding: 8px 6px;
  z-index: 999;
  transition: all 0.3s ease;
  color: var(--ui-text);
  border-right: 1px solid var(--ui-border);
  box-shadow: var(--ui-shadow-sm);
}

.sidebar.open {
  width: 260px;
}

.sidebar.open~.container {
  left: 260px;
  width: calc(100% - 260px);
}

.sidebar~.container {
  left: 78px;
  width: calc(100% - 78px);
}

.mobile-sidebar-trigger {
  display: none;
}

.sidebar-backdrop {
  display: none;
}
.sidebar .logo-details {
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px 10px;
  border-bottom: 1px solid var(--ui-border);
  gap: 10px;
}

.logo-details img {
  width: 80px;
  opacity: 0;
  transition: all 0.5s ease;
}

.sidebar .logo-details .logo_name {
  color: var(--ui-text);
  font-size: 14px;
  font-weight: 700;
  opacity: 0;
  transition: all 0.5s ease;
}

.sidebar.open .logo-details img,
.sidebar.open .logo-details .logo_name {
  opacity: 1;
}

.sidebar .logo-details #btn {
  position: absolute;
  top: 50%;
  right: 40%;
  transform: translateY(-50%);
  font-size: 22px;
  color: var(--ui-primary);
  transition: all 0.3s ease;
  font-size: 23px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
}

.sidebar.open .logo-details #btn {
  text-align: right;
  right: 0;
  margin-right: 10px;
}

.sidebar .nav-list {
  margin-top: 10px;
  height: calc(100% - 130px);
  min-height: auto;
  overflow-y: auto;
  display: block;
  padding-bottom: 56px;
  scrollbar-width: thin; /* Para navegadores compativeis*/
  scrollbar-color: #dedede var(--ui-surface);
}

.support-footer-link {
  position: absolute;
  left: 6px;
  right: 6px;
  bottom: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: var(--ui-primary);
  font-size: 11px;
  font-weight: 700;
  text-decoration: none;
  font-style: italic;
  opacity: .8;
}

.support-footer-link:hover {
  opacity: 1;
}

.support-footer-icon {
  width: 18px;
  height: 18px;
  opacity: .9;
}

.support-footer-text {
  display: none;
  text-decoration: underline;
  text-underline-offset: 4px;
}

.sidebar.open .support-footer-text {
  display: inline;
}

/* Estilo de barra de rolagem para navegadores Webkit (Chrome, Safari) */
.sidebar .nav-list::-webkit-scrollbar {
  width: 5px;
}

.sidebar .nav-list::-webkit-scrollbar-thumb {
  background-color: var(--ui-primary);
  border-radius: 10px;
}

.sidebar .nav-list::-webkit-scrollbar-track {
  background-color: var(--ui-surface);
}

.sidebar li {
  position: relative;
  list-style: none;
  border-bottom: 1px solid transparent;
}

.sidebar li:last-child {
  border-bottom: none;
}

.active-li a,
.active-li div {
  background-color: #f2f6ff !important;
  color: var(--ui-primary);
  border-radius: var(--ui-radius-md);
}

.sidebar.open .nav-list .tooltip {
  display: none;
}

.sidebar .nav-list .tooltip {
  position: absolute;
  top: 0;
  left: 60px;
  background-color: var(--ui-surface);
  color: var(--ui-primary);
  padding: 6px 20px;
  border-radius: 6px;
  box-shadow: var(--ui-shadow-sm);
  display: none;
  z-index: 3;
  transition: opacity .5s ease;
}

.nav-list li:hover .tooltip {
  display: block;
}

.sidebar li div .i:last-child {
  margin-left: auto;
}

.sidebar li a,
.sidebar li div {
  display: flex;
  height: auto;
  width: 100%;
  align-items: center;
  text-decoration: none;
  transition: all 0.2s ease;
  background: transparent;
  color: var(--ui-text);
  padding: 10px 12px;
  gap: 12px;
  border-radius: var(--ui-radius-md);
}

.sidebar.open li a,
.sidebar.open li div {
  padding: 14px;
}

.sidebar li a:hover,
.sidebar li div:hover {
  background: #f5f8ff;
}

.sidebar li div .i:last-child {
  margin-left: auto;
}

.sidebar li a .i-fa,
.sidebar li div .i-fa {
  font-size: 18px;
}

.ul-options {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 4px;
  background: transparent;
  margin: 4px 0 10px 0;
  padding: 0 0 10px 14px;
  width: auto;
  border-left: 1px dashed rgba(3, 78, 162, 0.2);
}

.sidebar:not(.open) .ul-options {
  display: none;
}

.ul-options .ul-options {
  margin: 2px 0 6px 0;
  padding-left: 12px;
  border-left: 1px dashed rgba(3, 78, 162, 0.15);
}

.ul-options .a-option {
  padding: 8px 0;
  background: transparent;
  opacity: .9;
  width: 100%;
  display: block;
}

.ul-options .a-option:hover {
  opacity: 1;
}

.ul-options li {
  border: none;
  background: transparent;
}

.ul-options li div,
.ul-options li a {
  padding: 6px 0;
  background: transparent;
  gap: 10px;
  border-radius: 6px;
  align-items: center;
  transition: background-color .15s ease;
}

.ul-options li div:hover,
.ul-options li a:hover {
  background: rgba(0,0,0,0.03);
}

.sidebar li a .links_name,
.sidebar li div span {
  color: var(--ui-text);
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: 0.4s;
}

.ul-options .links_name,
.ul-options .a-option {
  white-space: normal;
  line-height: 1.3;
  font-size: 13px;
  color: var(--ui-text);
  opacity: .85;
}

.sidebar.open li a .links_name,
.sidebar.open li div span {
  opacity: 1;
  pointer-events: auto;
}

.sidebar li a .links_name,
.sidebar li a .i,
.sidebar li div span,
.sidebar li div .i {
  color: var(--ui-primary);
}

.sidebar li a:hover .links_name,
.sidebar li a:hover .i,
.sidebar li div:hover span,
.sidebar li div:hover .i {
  transition: all 0.5s ease;
}


.sidebar .profile span:hover::after {
  opacity: 1;
}

.sidebar.open .profile span {
  display: block;
}

.sidebar.open #hide-icon {
  display: block;
}

.sidebar #hide-icon {
  display: none;
}

@media (max-width: 420px) {
  .sidebar li .tooltip {
    display: none;
  }
}

@media screen and (max-width: 800px) {
  .mobile-sidebar-trigger {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 12px;
    left: 12px;
    width: 42px;
    height: 42px;
    border-radius: 10px;
    border: 1px solid var(--ui-border);
    background: var(--ui-surface);
    color: var(--ui-primary);
    z-index: 1002;
    box-shadow: var(--ui-shadow-sm);
  }

  .sidebar-backdrop {
    display: block;
    position: fixed;
    inset: 0;
    background: rgba(17, 24, 39, 0.28);
    z-index: 998;
  }

  .sidebar.mobile {
    width: 260px;
    transform: translateX(-100%);
    padding: 8px 6px;
    box-shadow: var(--ui-shadow-sm);
  }

  .sidebar.mobile.open {
    transform: translateX(0);
  }

  .sidebar.mobile~.container,
  .sidebar.mobile.open~.container {
    left: 0;
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Sidebar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,2BAA2B;EAC3B,eAAe;EACf,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,qBAAqB,EAAE,gCAAgC;EACvD,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA,wEAAwE;AACxE;EACE,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;EACpC,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,mCAAmC;EACnC,wBAAwB;EACxB,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kCAAkC;IAClC,6BAA6B;IAC7B,wBAAwB;IACxB,aAAa;IACb,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,QAAQ;IACR,kCAAkC;IAClC,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,4BAA4B;IAC5B,gBAAgB;IAChB,+BAA+B;EACjC;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;;IAEE,OAAO;IACP,WAAW;EACb;AACF","sourcesContent":[".sidebar {\n  position: fixed;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 76px;\n  background: var(--ui-surface);\n  padding: 8px 6px;\n  z-index: 999;\n  transition: all 0.3s ease;\n  color: var(--ui-text);\n  border-right: 1px solid var(--ui-border);\n  box-shadow: var(--ui-shadow-sm);\n}\n\n.sidebar.open {\n  width: 260px;\n}\n\n.sidebar.open~.container {\n  left: 260px;\n  width: calc(100% - 260px);\n}\n\n.sidebar~.container {\n  left: 78px;\n  width: calc(100% - 78px);\n}\n\n.mobile-sidebar-trigger {\n  display: none;\n}\n\n.sidebar-backdrop {\n  display: none;\n}\n.sidebar .logo-details {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 12px 10px;\n  border-bottom: 1px solid var(--ui-border);\n  gap: 10px;\n}\n\n.logo-details img {\n  width: 80px;\n  opacity: 0;\n  transition: all 0.5s ease;\n}\n\n.sidebar .logo-details .logo_name {\n  color: var(--ui-text);\n  font-size: 14px;\n  font-weight: 700;\n  opacity: 0;\n  transition: all 0.5s ease;\n}\n\n.sidebar.open .logo-details img,\n.sidebar.open .logo-details .logo_name {\n  opacity: 1;\n}\n\n.sidebar .logo-details #btn {\n  position: absolute;\n  top: 50%;\n  right: 40%;\n  transform: translateY(-50%);\n  font-size: 22px;\n  color: var(--ui-primary);\n  transition: all 0.3s ease;\n  font-size: 23px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.sidebar.open .logo-details #btn {\n  text-align: right;\n  right: 0;\n  margin-right: 10px;\n}\n\n.sidebar .nav-list {\n  margin-top: 10px;\n  height: calc(100% - 130px);\n  min-height: auto;\n  overflow-y: auto;\n  display: block;\n  padding-bottom: 56px;\n  scrollbar-width: thin; /* Para navegadores compativeis*/\n  scrollbar-color: #dedede var(--ui-surface);\n}\n\n.support-footer-link {\n  position: absolute;\n  left: 6px;\n  right: 6px;\n  bottom: 8px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  color: var(--ui-primary);\n  font-size: 11px;\n  font-weight: 700;\n  text-decoration: none;\n  font-style: italic;\n  opacity: .8;\n}\n\n.support-footer-link:hover {\n  opacity: 1;\n}\n\n.support-footer-icon {\n  width: 18px;\n  height: 18px;\n  opacity: .9;\n}\n\n.support-footer-text {\n  display: none;\n  text-decoration: underline;\n  text-underline-offset: 4px;\n}\n\n.sidebar.open .support-footer-text {\n  display: inline;\n}\n\n/* Estilo de barra de rolagem para navegadores Webkit (Chrome, Safari) */\n.sidebar .nav-list::-webkit-scrollbar {\n  width: 5px;\n}\n\n.sidebar .nav-list::-webkit-scrollbar-thumb {\n  background-color: var(--ui-primary);\n  border-radius: 10px;\n}\n\n.sidebar .nav-list::-webkit-scrollbar-track {\n  background-color: var(--ui-surface);\n}\n\n.sidebar li {\n  position: relative;\n  list-style: none;\n  border-bottom: 1px solid transparent;\n}\n\n.sidebar li:last-child {\n  border-bottom: none;\n}\n\n.active-li a,\n.active-li div {\n  background-color: #f2f6ff !important;\n  color: var(--ui-primary);\n  border-radius: var(--ui-radius-md);\n}\n\n.sidebar.open .nav-list .tooltip {\n  display: none;\n}\n\n.sidebar .nav-list .tooltip {\n  position: absolute;\n  top: 0;\n  left: 60px;\n  background-color: var(--ui-surface);\n  color: var(--ui-primary);\n  padding: 6px 20px;\n  border-radius: 6px;\n  box-shadow: var(--ui-shadow-sm);\n  display: none;\n  z-index: 3;\n  transition: opacity .5s ease;\n}\n\n.nav-list li:hover .tooltip {\n  display: block;\n}\n\n.sidebar li div .i:last-child {\n  margin-left: auto;\n}\n\n.sidebar li a,\n.sidebar li div {\n  display: flex;\n  height: auto;\n  width: 100%;\n  align-items: center;\n  text-decoration: none;\n  transition: all 0.2s ease;\n  background: transparent;\n  color: var(--ui-text);\n  padding: 10px 12px;\n  gap: 12px;\n  border-radius: var(--ui-radius-md);\n}\n\n.sidebar.open li a,\n.sidebar.open li div {\n  padding: 14px;\n}\n\n.sidebar li a:hover,\n.sidebar li div:hover {\n  background: #f5f8ff;\n}\n\n.sidebar li div .i:last-child {\n  margin-left: auto;\n}\n\n.sidebar li a .i-fa,\n.sidebar li div .i-fa {\n  font-size: 18px;\n}\n\n.ul-options {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  background: transparent;\n  margin: 4px 0 10px 0;\n  padding: 0 0 10px 14px;\n  width: auto;\n  border-left: 1px dashed rgba(3, 78, 162, 0.2);\n}\n\n.sidebar:not(.open) .ul-options {\n  display: none;\n}\n\n.ul-options .ul-options {\n  margin: 2px 0 6px 0;\n  padding-left: 12px;\n  border-left: 1px dashed rgba(3, 78, 162, 0.15);\n}\n\n.ul-options .a-option {\n  padding: 8px 0;\n  background: transparent;\n  opacity: .9;\n  width: 100%;\n  display: block;\n}\n\n.ul-options .a-option:hover {\n  opacity: 1;\n}\n\n.ul-options li {\n  border: none;\n  background: transparent;\n}\n\n.ul-options li div,\n.ul-options li a {\n  padding: 6px 0;\n  background: transparent;\n  gap: 10px;\n  border-radius: 6px;\n  align-items: center;\n  transition: background-color .15s ease;\n}\n\n.ul-options li div:hover,\n.ul-options li a:hover {\n  background: rgba(0,0,0,0.03);\n}\n\n.sidebar li a .links_name,\n.sidebar li div span {\n  color: var(--ui-text);\n  font-size: 13px;\n  font-weight: 600;\n  white-space: nowrap;\n  opacity: 0;\n  pointer-events: none;\n  transition: 0.4s;\n}\n\n.ul-options .links_name,\n.ul-options .a-option {\n  white-space: normal;\n  line-height: 1.3;\n  font-size: 13px;\n  color: var(--ui-text);\n  opacity: .85;\n}\n\n.sidebar.open li a .links_name,\n.sidebar.open li div span {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.sidebar li a .links_name,\n.sidebar li a .i,\n.sidebar li div span,\n.sidebar li div .i {\n  color: var(--ui-primary);\n}\n\n.sidebar li a:hover .links_name,\n.sidebar li a:hover .i,\n.sidebar li div:hover span,\n.sidebar li div:hover .i {\n  transition: all 0.5s ease;\n}\n\n\n.sidebar .profile span:hover::after {\n  opacity: 1;\n}\n\n.sidebar.open .profile span {\n  display: block;\n}\n\n.sidebar.open #hide-icon {\n  display: block;\n}\n\n.sidebar #hide-icon {\n  display: none;\n}\n\n@media (max-width: 420px) {\n  .sidebar li .tooltip {\n    display: none;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .mobile-sidebar-trigger {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    position: fixed;\n    top: 12px;\n    left: 12px;\n    width: 42px;\n    height: 42px;\n    border-radius: 10px;\n    border: 1px solid var(--ui-border);\n    background: var(--ui-surface);\n    color: var(--ui-primary);\n    z-index: 1002;\n    box-shadow: var(--ui-shadow-sm);\n  }\n\n  .sidebar-backdrop {\n    display: block;\n    position: fixed;\n    inset: 0;\n    background: rgba(17, 24, 39, 0.28);\n    z-index: 998;\n  }\n\n  .sidebar.mobile {\n    width: 260px;\n    transform: translateX(-100%);\n    padding: 8px 6px;\n    box-shadow: var(--ui-shadow-sm);\n  }\n\n  .sidebar.mobile.open {\n    transform: translateX(0);\n  }\n\n  .sidebar.mobile~.container,\n  .sidebar.mobile.open~.container {\n    left: 0;\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
